// Dünne, fehlersichere Aufrufe der Desktop-App (window.crmDesktop, im Browser nicht vorhanden). Alles optional:
// ohne App oder mit älterer Fassung passiert einfach nichts.
import { istMikrofonGesperrt } from "./logik";

function sicher(fn: (() => unknown) | undefined): void {
  try {
    if (fn) void Promise.resolve(fn()).catch(() => undefined);
  } catch {
    /* ältere App-Fassung ohne diese Funktion */
  }
}

export function desktopTelefonStatus(verbunden: boolean): void {
  const d = window.crmDesktop;
  sicher(d?.telefonStatus ? () => d.telefonStatus(verbunden) : undefined);
}

export function desktopEingehend(info: { wer: string; status: string; nummer: string; grund: string }): void {
  const d = window.crmDesktop;
  sicher(d?.eingehend ? () => d.eingehend(info) : undefined);
}

export function desktopEingehendEnde(): void {
  const d = window.crmDesktop;
  sicher(d?.eingehendEnde ? () => d.eingehendEnde() : undefined);
}

let letzteHilfe = 0;

/**
 * Zeigt in der Desktop-App den Erklär-Dialog, wenn der Fehler eine Mikrofonsperre ist (höchstens einmal je Minute,
 * damit wiederholte Fehler desselben Anrufs keine Dialoge stapeln). Gibt zurück, ob es eine Sperre war.
 */
export function mikrofonHilfeBeiSperre(fehler: unknown, jetztMs: number = Date.now()): boolean {
  if (!istMikrofonGesperrt(fehler)) return false;
  if (jetztMs - letzteHilfe < 60_000) return true;
  letzteHilfe = jetztMs;
  const d = window.crmDesktop;
  sicher(d?.mikrofonHilfe ? () => d.mikrofonHilfe() : undefined);
  return true;
}
